import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, BookOpen, Heart, Users } from 'lucide-react';
import { smoothScrollTo } from './CTAButton';
export function BonusSection() {
  const bonuses = [{
    id: 1,
    title: 'Curso para Optimizar tu Dinero en 5 Pasos',
    desc: 'Aprendé principios simples para mejorar tu relación con el dinero.',
    icon: <DollarSign className="w-16 h-16 text-green-400" data-id="element-37" />,
    bg: 'from-green-900 to-black'
  }, {
    id: 2,
    title: 'Curso de Lectura Rápida',
    desc: 'Aprendé técnicas para leer más rápido y absorber mejor la información.',
    icon: <BookOpen className="w-16 h-16 text-blue-400" data-id="element-38" />,
    bg: 'from-blue-900 to-black'
  }, {
    id: 3,
    title: 'Ebook de Gratitud y Amor Propio',
    desc: 'Ejercicios simples para mejorar tu bienestar emocional.',
    icon: <Heart className="w-16 h-16 text-pink-400" data-id="element-39" />,
    bg: 'from-pink-900 to-black'
  }, {
    id: 4,
    title: 'Ebook de Relaciones y Conexión Personal',
    desc: 'Ideas prácticas para mejorar tus relaciones y tu comunicación.',
    icon: <Users className="w-16 h-16 text-purple-400" data-id="element-40" />,
    bg: 'from-purple-900 to-black'
  }];
  return <section className="py-10 px-4 bg-[#111827]" data-id="element-41">
      <div className="max-w-6xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-43">
          <div className="text-center mb-8" data-id="element-44">
            <h2 className="text-4xl md:text-5xl font-black text-[#8FF650] mb-2 uppercase tracking-tight" data-id="element-45">
              🎁 REGALOS ESPECIALES
            </h2>
            <h3 className="text-2xl md:text-3xl font-black text-white mb-1" data-id="element-46">
              BONOS INCLUIDOS HOY
            </h3>
            <p className="text-lg font-bold text-gray-400 uppercase tracking-widest" data-id="element-47">
              (Sin costo adicional)
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-48">
            {bonuses.map(bonus => <button key={bonus.id} onClick={() => smoothScrollTo('compra', 2500)} className="group block w-full text-left bg-gray-900 rounded-2xl p-5 border border-gray-700 hover:border-[#8FF650] transition-colors shadow-lg" data-id="element-49">
                <div className="flex flex-col sm:flex-row gap-5 items-center sm:items-start" data-id="element-50">
                  {/* CSS Mockup 1080x1080 aspect ratio (square) */}
                  <div className={`w-full sm:w-1/3 aspect-square rounded-xl bg-gradient-to-br ${bonus.bg} flex flex-col items-center justify-center p-4 text-center shadow-inner transform group-hover:scale-105 transition-transform duration-500 border-2 border-gray-800 relative overflow-hidden flex-shrink-0`} data-id="element-51">
                    <div className="absolute top-0 right-0 bg-[#8FF650] text-black text-[10px] font-black px-2 py-0.5 rounded-bl-lg uppercase" data-id="element-52">
                      Bono #{bonus.id}
                    </div>
                    {bonus.icon}
                  </div>

                  <div className="w-full sm:w-2/3 text-center sm:text-left" data-id="element-53">
                    <div className="inline-block bg-gray-800 text-white font-black px-3 py-1 rounded-full text-xs mb-2 uppercase border border-gray-700" data-id="element-54">
                      🎁 Bono #{bonus.id}
                    </div>
                    <h4 className="text-xl font-black text-white mb-2 leading-tight" data-id="element-55">
                      {bonus.title}
                    </h4>
                    <p className="text-sm text-gray-400 font-medium mb-4" data-id="element-56">
                      {bonus.desc}
                    </p>
                    <div className="bg-gray-800 p-3 rounded-lg border border-gray-700 inline-block w-full text-center" data-id="element-57">
                      <p className="text-gray-500 font-bold line-through text-sm mb-0.5" data-id="element-58">
                        Valor: $14.999
                      </p>
                      <p className="text-lg font-black text-[#8FF650] uppercase animate-pulse" data-id="element-59">
                        HOY: GRATIS
                      </p>
                    </div>
                  </div>
                </div>
              </button>)}
          </div>

          <div className="text-center bg-[#8FF650] py-4 px-4 rounded-xl shadow-lg" data-id="element-60">
            <p className="text-xl md:text-2xl font-black text-black uppercase" data-id="element-61">
              Estos bonos son GRATIS por el día de hoy
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}